module.exports = __webpack_public_path__ + "static/Net-51698ce438debe5de15e486730e058d4.jpg";